import React from 'react';
import { Table } from 'components/ui';
import EditIPPoolCell from './components/EditIPPoolCell';
import DeleteDomainButton from './components/DeleteDomainButton';
import MoveToPreWarmupButton from './components/MoveToPreWarmupButton';
import DistributionChanger from './components/DistributionChanger';

export default function WarmedUpDomain({ domains }) {
  /**
   * Convert single to accumulated style and multiply by 100
   * Example: [0.25, 0.33] => [25, 58]
   */
  const initialDistribution = domains.map((e, index) => {
    const sumBefore = domains
      .filter((d, i) => i < index)
      .reduce((a, b) => a + b.percentageDistribution, 0);
    return parseInt((e.percentageDistribution + (sumBefore || 0)) * 100);
  });
  const [range, setRange] = React.useState(initialDistribution);
  const columns = [
    {
      title: 'Domain',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'IP Pool Name',
      align: 'center',
      dataIndex: 'ipPool',
      key: 'ipPool',
      render: (value, row) => {
        return <EditIPPoolCell domain={row} key={row.ipPool} />;
      },
    },
    {
      title: 'Distribution',
      dataIndex: 'distribution',
      align: 'center',
      render: (value, row, index) => {
        const currentPercentage =
          row.name === 'turing.com' ? 100 : range[index];
        return currentPercentage - (range[index - 1] || 0) + '%';
      },
    },
    {
      key: 'actions',
      align: 'center',
      render: (value, row) => {
        if (row.name === 'turing.com') return null;
        return (
          <div
            className="flex items-center space-x-2"
            style={{ justifyContent: 'center' }}
          >
            <MoveToPreWarmupButton domain={row} />
            <DeleteDomainButton domain={row} />
          </div>
        );
      },
    },
  ];
  return (
    <>
      <Table
        columns={columns}
        dataSource={domains}
        pagination={false}
        rowKey="name"
      />
      {domains.length > 1 && (
        <DistributionChanger
          domains={domains}
          initialDistribution={initialDistribution}
          key={initialDistribution}
          range={range}
          setRange={setRange}
        />
      )}
    </>
  );
}
